/**
 * ConfirmModal — small yes/no confirmation dialog (replaces window.confirm for
 * a consistent, on-brand look).
 */
import React from 'react';
import Modal from './Modal';

export default function ConfirmModal({
  open, onClose, onConfirm, title, message, confirmLabel = 'Delete', danger = true,
}) {
  return (
    <Modal open={open} onClose={onClose} title={title} maxWidth={400}>
      <p className="ev-confirm__msg">{message}</p>
      <div className="ev-confirm__actions">
        <button className="ev__btn" onClick={onClose}>Cancel</button>
        <button className={`ev__btn ${danger ? 'ev__btn--danger-solid' : 'ev__btn--primary'}`} onClick={onConfirm}>
          {confirmLabel}
        </button>
      </div>
    </Modal>
  );
}
